import React, { useMemo } from 'react';
import { AutocompleteComponent } from '../../../../../Components';
import useFetchList from '../../../../../Hooks/useFetchData';
import { GetActivityTypes } from '../../../../../Services';

const ActivityTypesAutocomplete = ({
  categoryId,
  onTypeChange,
  selectedType,
  ...props
}) => {
  const params = useMemo(
    () => ({ pageSize: 25, pageIndex: 1, categoryId }),
    [categoryId]
  );
  const { data, loading } = useFetchList(GetActivityTypes, params);
  return (
    <AutocompleteComponent
      data={data.result ?? []}
      selectedValues={selectedType}
      multiple={false}
      isDisabled={loading}
      isLoading={loading}
      onChange={(_e, newType) => onTypeChange(newType)}
      displayLabel={(option) => option?.activityTypeName ?? ''}
      labelValue={'Activity Type'}
      withoutSearchButton
      {...props}
    />
  );
};
export default ActivityTypesAutocomplete;
